import React from 'react';
import move from 'lodash-move';
import { get, set, getOr, isEmpty } from 'lodash/fp';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { List } from 'rsuite';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import SortableItems from '../SortableItems';

const CategoryList = styled(List)`
  box-shadow: none;
`;

const CategoryListItem = styled(List.Item)`
  padding: 0;
  box-shadow: none;
  > .rs-list-item-content {
    > div:first-child {
      &:hover {
        cursor: move;
      }
      padding: 10px;
      text-align: center;
      background-color: #efefef;
      font-weight: 500;
      > h6 {
        font-size: 16px;
        text-transform: uppercase;
        margin-bottom: 5px;
      }
    }
  }
`;

const SortableItem = SortableElement(
  ({ data: { id, name }, items, onSortEnd, ...props }) => (
    <CategoryListItem {...props}>
      <div>
        <h6>{name}</h6>
      </div>
      {!isEmpty(items) && (
        <SortableItems categoryId={id} data={items} onSortEnd={onSortEnd} />
      )}
    </CategoryListItem>
  )
);

const SortableList = SortableContainer(
  ({ categories, itemsByCategory, onItemsSortEnd }) => (
    <CategoryList>
      {categories.map((category, index) => (
        <SortableItem
          key={`${category.id}`}
          index={index}
          data={category}
          items={get(category.id, itemsByCategory)}
          onSortEnd={onItemsSortEnd}
          className={getOr(true, 'isVisible', category) ? '' : 'hidden'}
        />
      ))}
    </CategoryList>
  )
);

const SortableCategories = ({
  categories,
  itemsByCategory,
  onSortEnd,
  itemsOnSortEnd
}) => {
  const handleSortEnd = ({ oldIndex, newIndex }) => {
    const sortedData = move(categories, oldIndex, newIndex).map((each, i) =>
      set('position', i + 1, each)
    );
    onSortEnd(sortedData);
  };

  return (
    <SortableList
      lockAxis="y"
      categories={categories}
      itemsByCategory={itemsByCategory}
      onItemsSortEnd={itemsOnSortEnd}
      onSortEnd={handleSortEnd}
    />
  );
};

SortableCategories.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  itemsByCategory: PropTypes.shape({}).isRequired,
  onSortEnd: PropTypes.func.isRequired,
  itemsOnSortEnd: PropTypes.func.isRequired
};

export default SortableCategories;
